import React, { useEffect, useState } from "react";
import {
  Table,
  Card,
  Button,
  Input,
  Space,
  Row,
  Col,
  Typography,
  message,
  Modal,
  Tag,
} from "antd";
import {
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import axiosInstance from "../../../configs";
import { canDelete, MODULES } from "../../../utils/rbac";

const { Title, Text } = Typography;
const { Search } = Input;

export default function ContactList() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");

  const fetchData = async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.get("/contact", {
        params: { name: search },
      });
      setData(res.data || []);
    } catch (err) {
      console.error(err);
      message.error("Gagal mengambil data kontak");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [search]);

  const handleDelete = (id) => {
    Modal.confirm({
      title: "Hapus Kontak?",
      content: "Data yang dihapus tidak dapat dikembalikan.",
      okText: "Ya, Hapus",
      okType: "danger",
      onOk: async () => {
        try {
          await axiosInstance.delete(`/contact/${id}`);
          message.success("Kontak berhasil dihapus");
          fetchData();
        } catch (e) {
          message.error(e.response?.data?.error || "Gagal menghapus kontak");
        }
      },
    });
  };

  const columns = [
    {
      title: "Nama",
      dataIndex: "name",
      width: 150,
      ellipsis: true,
      render: (text) => <Text strong>{text}</Text>,
    },
    {
      title: "Tipe",
      dataIndex: "contact_type",
      width: 90,
      render: (val) => {
        if (val === 1) return <Tag color="blue">Non Group</Tag>;
        if (val === 0) return <Tag color="orange">Group</Tag>;
        return val;
      },
    },
    {
      title: "Alamat",
      dataIndex: "address",
      ellipsis: true,
      responsive: ["md"],
    },
    {
      title: "Email/Telp",
      key: "contact",
      width: 150,
      responsive: ["sm"],
      render: (_, r) => (
        <div>
          {r.email && <div style={{ fontSize: 12 }}>{r.email}</div>}
          {r.phone && (
            <Text type="secondary" style={{ fontSize: 12 }}>
              {r.phone}
            </Text>
          )}
        </div>
      ),
    },
    {
      title: "Aksi",
      key: "action",
      width: 90,
      align: "center",
      fixed: "right",
      render: (_, r) => (
        <Space size="small">
          <Link to={`/referensi/kontak/edit/${r.id_contact}`}>
            <Button icon={<EditOutlined />} size="small" type="primary" />
          </Link>
          {canDelete(MODULES.REFERENSI) && (
            <Button
              icon={<DeleteOutlined />}
              size="small"
              danger
              onClick={() => handleDelete(r.id_contact)}
            />
          )}
        </Space>
      ),
    },
  ];

  return (
    <Card bodyStyle={{ padding: "16px" }}>
      <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
        <Col xs={24} md={12}>
          <Title level={4} style={{ margin: 0 }}>
            Daftar Pemasok / Pemilik
          </Title>
        </Col>
        <Col xs={24} md={12}>
          <Space wrap style={{ width: "100%", justifyContent: "flex-end" }}>
            <Button icon={<ReloadOutlined />} onClick={fetchData}>
              Refresh
            </Button>
            <Link to="/referensi/kontak/create">
              <Button type="primary" icon={<PlusOutlined />}>
                Tambah
              </Button>
            </Link>
          </Space>
        </Col>
      </Row>

      <Row style={{ marginBottom: 16 }}>
        <Col xs={24} sm={12} md={8}>
          <Search
            placeholder="Cari nama..."
            onSearch={(val) => setSearch(val)}
            allowClear
            enterButton
          />
        </Col>
      </Row>

      <Table
        dataSource={data}
        columns={columns}
        rowKey="id_contact"
        loading={loading}
        size="small"
        scroll={{ x: 500 }}
        pagination={{
          pageSize: 20,
          size: "small",
          showTotal: (t) => `${t} data`,
        }}
      />
    </Card>
  );
}
